import { Box, Typography } from '@mui/material';
import { DoseUnit } from '~/domain/dicom/dicomDose';

export default function DoseTargets({
    targets,
    units,
}: {
    targets: { name: string; doseQuantity: number }[];
    units: DoseUnit;
}) {
    return (
        <Box>
            {targets.map((t) => (
                <Typography
                    display="flex"
                    gap={0.5}
                    alignItems="flex-end"
                    lineHeight={1.2}
                    key={t.name}
                    fontSize={12}
                >
                    {t.name}
                    <Typography fontSize={11} color="primary" lineHeight={1.2}>
                        {t.doseQuantity}
                        {units}
                    </Typography>
                </Typography>
            ))}
        </Box>
    );
}
